const state = {
  // favorites page
  isDraggingElement: false,
  isDraggingGroup: false,
  draggingElementId: '',

  isSelectedAllElements: false,
  selectedElementsId: [],
};

const getters = {
  // favorites page
  isDraggingElement: state => state.isDraggingElement,
  isDraggingGroup: state => state.isDraggingGroup,
  draggingElementId: state => state.draggingElementId,

  selectedElementsId: state => state.selectedElementsId,
};

const mutations = {
  setIsSelectAllElements(state, bool) {
    state.isSelectedAllElements = bool;
  },
  // favorites page
  setIsDraggingElement(state, bool) {
    state.isDraggingElement = bool;
  },
  setIsDraggingGroup(state, bool) {
    state.isDraggingGroup = bool;
  },
  setDraggingElementId(state, elementId) {
    state.draggingElementId = elementId;
  },
  setSelectedElementsId(state, elements) {
    console.log('setSelectedElementsId', elements);
    state.selectedElementsId = elements;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
